module.exports = __webpack_public_path__ + "static/image/company/principle.jpg?9efcd269";